import { ReactNode } from 'react';

import PanelCallOutIcon from '../Icons/PanelCallOutIcon';

interface IDebtConCallOutProps {
    text?: string;
    classes: string;
    icon?: ReactNode;
    includeBaseText?: boolean;
}

const DebtConCallOut = ({
    text,
    classes,
    icon = <PanelCallOutIcon />,
    includeBaseText = true,
}: IDebtConCallOutProps) => {
    const baseText = 'You can find this in your statements.';
    const displayText = includeBaseText
        ? text
            ? `${baseText} ${text}`
            : baseText
        : text || '';

    return (
        <div
            className={`text-sm flex bg-almond-300 rounded-lg py-5 px-4 items-center ${classes}`}
        >
            <div className='flex-shrink-0'>{icon}</div>
            <p className='ml-3 leading-120% flex-grow'>{displayText}</p>
        </div>
    );
};

export default DebtConCallOut;
